// extracted by mini-css-extract-plugin
export default {"page_info":"PaginationGoTo_page_info__UM+Yy","input":"PaginationGoTo_input__txlGY"};